/**
 * SummaryStatCardGrid — wraps multiple summary stat cards in a responsive grid.
 */
import { cn } from "@/utils/cn";
import type { SummaryStatCardGridProps } from "./SummaryStatCardGrid.types";
import { summaryStatCardGridRootClass } from "./SummaryStatCardGrid.styles";

export type { SummaryStatCardGridProps } from "./SummaryStatCardGrid.types";

export function SummaryStatCardGrid({ children, className }: SummaryStatCardGridProps) {
  return <div className={cn(summaryStatCardGridRootClass, className)}>{children}</div>;
}
